<template>
    <div class="content content-aligned">
    <h1 style="text-align:left!important;">Indsend spil til Coding Class Finalen 2024</h1>

    <p style="text-align:left!important;">

Vi er nu i fuld gang med at arrangere årets store Coding Class Finale, <br> 
som i år bliver afholdt tirsdag d. 25. juni på UCL i Odense. <br><br>

Her i Odense skal vi finde 6 spil, som skal dyste mod 6 spil/projekter fra København <br> 
i kategorierne Gaming, Kodning og Innovation. <br><br>

Vi opfordrer alle klasser, der har haft Coding Class i dette skoleår, til at sende 1-5 spil afsted til os. <br> 
På den måde har I chancen for at blive udtaget som et af de 6 spil vi har med til finalen. <br><br>

Hvis et spil fra jeres klasse bliver udvalgt, skal hele klassen med til finalen d. 25. juni på UCL i Odense. <br>
Hvis I ikke kan deltage denne dag, kan I desværre ikke komme i betragtning til en finaleplads. <br>
<br>
For at vi kan bedømme spillene skal de sendes til os. <br>
Saml elevernes spil-filer (op til 5 spil) i en mappe på Google Drev og del den med <strong> mett94m3@appsodense.dk </strong> </p>
        <br>
        
        <h2 style="text-align:left!important;">For at sende et spil til os, skal du gøre følgende: </h2> 

      
        <p style="text-align:left!important;">
       <strong> 1. </strong>Når du er inde på spillet i CodingLab skal du op under Fil og trykke på "Gem på din computer" <br>
       <strong> 2. </strong>Derefter skal du ændre filnavnet til dit og din makkers fornavn, klasse og skole.<br>&nbsp; &nbsp; &nbsp;F.eks. MetteogMartin6AUngdomsskolen.sb3 <br>
        <strong> 3. </strong>Til sidst skal du dele filen med din lærer på Google Drev. <br>
        <strong> 4. </strong>Til læreren: Når du har modtaget spil-filerne fra eleverne, skal du samle dem i en mappe,<br>&nbsp; &nbsp; &nbsp;navngivet med skole og klasse, og dele den med mett94m3@appsodense.dk <br>
      </p>
      <br>
         <h2>Her kan du se hvordan du downloader spillet fra CodingLab</h2>
        <div class="content--centered">
            <EmbedYoutube class="video-tut-embed" id="TICeOIGr9z8"/>
        </div>
        <br>
        <h2>Vi glæder os til at se og prøve jeres spil!</h2>
        <br>
    </div>
</template>

<script>
import EmbedYoutube from "@/components/YoutubeEmbed";

export default {
  name: "Finale2023",
    components: {
        EmbedYoutube
    },
};
</script>

<style scoped> li {margin-bottom:10px; margin-left:0px; font-size:18px;}

</style>





// WEBPACK FOOTER //
// src/components/pages/next-finale.vue